import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { RealEstateDataPageComponentData } from 'types'
import VisibilitySensor from 'react-visibility-sensor'
import CountUp from 'react-countup'
import Image from '@components/Image'
import { useInView } from 'react-intersection-observer'

const Kpi_2 = (props: RealEstateDataPageComponentData) => {
  const { title, image_gatsby, kpis, kpiAnimation, is_short, darkMode } = props
  const { ref, inView } = useInView({
    triggerOnce: false, // Cargar solo una vez cuando sea visible
  })
  const KpiItemTitle = (value: string, simbol: any = null, subtitle?: string) => {
    if (kpiAnimation) {
      return (
        // inView && (
        true && (
          <>
            <h2 className="kpi-title d-flex align-items-center">
              {simbol ? (
                <span className={'kpi-simbol ' + (is_short ? 'order-2' : 'order-1')}>{simbol}</span>
              ) : null}
              <div className={'d-flex ' + (is_short ? 'order-1' : 'order-2')}>
                <CountUp
                  start={0}
                  separator="."
                  decimals={value.includes('.') ? 1 : 0}
                  decimal=","
                  // decimals={1}
                  duration={5}
                  className={'kpi-countup '}
                  end={parseFloat(value)}
                />
              </div>
            </h2>
            {subtitle && <p className="ms-2 text-secondary mb-2">{subtitle}</p>}
          </>
        )
      )
    } else {
      return (
        <>
          <h2 className="kpi-title d-flex">
            {simbol ? (
              <span className={'kpi-simbol ' + (is_short ? 'order-2' : 'order-1')}>{simbol}</span>
            ) : null}
            <span className={'kpi-value ' + (is_short ? 'order-1' : 'order-2')}>{value}</span>
          </h2>
          {subtitle && <p className="ms-3 text-secondary mb-2">{subtitle}</p>}
        </>
      )
    }
  }

  const KpiImg = () =>
    image_gatsby && (
      <Image
        className="image-kpi position-absolute"
        objectFit="cover"
        alt="image-kpi"
        image={image_gatsby!}
      />
    )

  return (
    <section
      ref={ref}
      className={'kpi-container b p-y-config ' + (darkMode ? 'dark-mode' : '')}
    >
      <Container fluid>
        <Row className="kpi-row">
          <Col
            xs={12}
            lg={6}
            className="col-title position-relative"
          >
            <h2 className="title text-center text-uppercase text-lg-start mb-5 mb-lg-0 mx-auto">
              {title}
            </h2>
            {KpiImg()}
          </Col>
          <Col
            xs={12}
            lg={{ span: 5, offset: 1 }}
            className="col-content position-relative"
          >
            <div className="kpi-wrapper d-flex flex-column justify-content-center">
              {kpis?.map((kpi, i) => (
                <div
                  className="kpi-item d-flex flex-column"
                  key={i}
                >
                  <div
                    className={
                      'kpi d-flex align-items-center justify-content-lg-start justify-content-center text-center text-lg-start ' +
                      (is_short ? 'order-2' : 'order-1')
                    }
                  >
                    {KpiItemTitle(kpi?.value!, kpi?.simbol!, kpi?.subtitle!)}
                  </div>
                  <h4
                    className={'kpi-paragraph text-uppercase ' + (is_short ? 'order-1' : 'order-2')}
                  >
                    {kpi?.paragraph!}
                  </h4>
                </div>
              ))}
            </div>
            {KpiImg()}
          </Col>
        </Row>
      </Container>
    </section>
  )
}

export default Kpi_2
